import OwnImage from "@ui/components/ui/event/OwnImage";

const EmbedFooter = () => {
  return (
    <div className="mt-auto flex w-full bg-blue-700 p-4">
      <div className="flex flex-1">
        <p className="my-auto mr-1 h-fit text-white">Propulsé par</p>
        <OwnImage
          src="/images/logos/logo_connect_events_store.png"
          alt="logo Connect'Events"
          className="static h-8 w-auto p-1"
        />
        <p className="my-auto h-fit text-white">Connect&apos;Events</p>
      </div>
    </div>
  );
};

export default EmbedFooter;
